module.exports = __webpack_public_path__ + "static/media/grace.62d70e8a.png";